import { ProvisionedConstants, STAGE } from 'src/constants';

const FRIDA_TO_RDP_STAGE = {
  [STAGE.DEV]: 'beta',
  [STAGE.BETA]: 'beta',
  [STAGE.GAMMA]: 'gamma',
  [STAGE.PROD_NA]: 'prod',
} as const;

export const getRdpStage = () => FRIDA_TO_RDP_STAGE[ProvisionedConstants.STAGE as STAGE] ?? 'alpha';
